import styled from 'styled-components';

export const GameJackpotBarToggleSwitchBox = styled.label`
  display: inline-block;
  position: relative;
  min-width: 40px;
  height: 16px;
  margin: 12px;
`;